module.exports = __webpack_public_path__ + "static/media/imagingResultIcon.2202b463.png";